import React, { useEffect, useState } from "react";
import { subscribeQueue, cancelJob, retryJob } from "@/lib/uploadQueue";
import { Video, X, RotateCcw, AlertTriangle } from "lucide-react";

/** Barra fissa: mostra l'avanzamento dei video in invio in background,
 *  così l'addetta vede che procede da solo anche fuori dalla pulizia. */
export default function VideoQueueBanner() {
  const [jobs, setJobs] = useState([]);
  useEffect(() => subscribeQueue((all) => setJobs(all.filter((j) => j.status !== "done"))), []);
  if (!jobs.length) return null;
  const j = jobs[0];
  const stuck = j.status === "error" || (j.attempts || 0) >= 2;
  return (
    <div className={`sticky top-0 z-40 px-3 py-2 text-xs font-bold flex items-center gap-2 text-white ${stuck ? "bg-red-600" : "bg-blue-600"}`}
         data-testid="video-queue-banner">
      {stuck ? <AlertTriangle className="w-4 h-4 shrink-0" /> : <Video className="w-4 h-4 shrink-0" />}
      <span className="truncate">
        {stuck
          ? `${j.kind === "proof" ? "Prova" : "Video"} bloccato al ${j.pct}%${j.error ? ` · ${j.error}` : ""}`
          : j.status === "uploading"
            ? `Invio ${j.kind === "proof" ? "prova" : "video"} ${j.pct}%`
            : `${j.kind === "proof" ? "Prova" : "Video"} in attesa di rete`}
        {jobs.length > 1 ? ` · altri ${jobs.length - 1} in coda` : ""}
      </span>
      {!stuck && (
        <div className="flex-1 h-1.5 rounded-full bg-white/30 overflow-hidden min-w-[40px]">
          <div className="h-full bg-white transition-all" style={{ width: `${j.pct}%` }} />
        </div>
      )}
      {stuck && (
        <button
          type="button"
          onClick={() => retryJob(j.id)}
          title="Riprova l'invio"
          className="shrink-0 p-1 rounded-full hover:bg-white/20"
          data-testid="video-queue-retry"
        >
          <RotateCcw className="w-4 h-4" />
        </button>
      )}
      <button
        type="button"
        onClick={() => cancelJob(j.id)}
        title="Elimina questo video dalla coda"
        className="shrink-0 p-1 rounded-full hover:bg-white/20"
        data-testid="video-queue-cancel"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
